import { Component, EventEmitter, Inject, OnInit, Output } from '@angular/core';
import { MatTableDataSource, MatTableModule } from '@angular/material/table';
import { AllDataColumn, AllDataModel, AllDataRow } from '../models/all-data.model';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { BaseModalComponent } from '@app/components/base-modal/base-modal.component';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { DownloadAsCsvData } from '../models/download-as-csv-data.model';

@Component({
  standalone: true,
  selector: 'app-all-data',
  imports: [MatTableModule, BaseModalComponent, MatButtonModule, MatIconModule],
  templateUrl: './all-data.component.html',
  styleUrl: './all-data.component.scss',
})
export class AllDataComponent implements OnInit {
  protected tableColumns: AllDataColumn[] = ['label', 'aggregation', 'count', 'percentage'];
  protected tableDataSource = new MatTableDataSource<AllDataRow>();

  @Output() downloadCsv = new EventEmitter<DownloadAsCsvData>();

  constructor(
    private readonly dialogRef: MatDialogRef<AllDataComponent>,
    @Inject(MAT_DIALOG_DATA) protected allData: AllDataModel,
  ) {}

  public ngOnInit(): void {
    if (this.allData) {
      this.tableDataSource.data = this.allData?.data;

      // Don't show the columns passed to be excluded.
      this.tableColumns = this.tableColumns.filter((col) => !this.allData.excludeColumns.includes(col));
    }
  }

  protected downloadAsCsv(): void {
    this.downloadCsv.emit({
      chartType: this.allData.chartType,
      labelColumnName: this.allData.labelColumnName,
      data: this.allData.data,
    });
  }

  public onCancel(): void {
    this.dialogRef.close();
  }
}
